import state from './moduleDashboardState.js'
import mutations from './moduleDashboardMutations.js'
import actions from './moduleDashboardActions.js'
import getters from './moduleDashboardGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

